/**
 * @fileoverview PUT handler for the "/:app_group_id/canvas_qa_runs/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { canvasQaRunCacheKeys } from "./constants";
import type { PutCanvasQaRunProps, PutCanvasQaRunResult } from "./types";

export const putCanvasQaRun = reactQueryMutationAdapter(
  canvasQaRunCacheKeys,
  (props: PutCanvasQaRunProps): Promise<PutCanvasQaRunResult> => {
    return fetch(
      `/${props.appGroupId}/canvas_qa_runs/${props.canvasId}`,
      "PUT",
      {
        // The backend replaces only this scope's slice of the stored results.
        scope: props.scope,
        run_id: props.runId,
        selected_agent_ids: props.selectedAgentIds,
        results: props.results,
        rule_resolutions: props.ruleResolutions,
        last_run_at: props.lastRunAt,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
